import type { JobItem, Document } from "@kanda-libs/ks-frontend-services";
import { StringIndexedObject } from "@kanda-libs/ks-component-ts";
import {
  type LineItemVariant,
  VARIANTS,
  VAT_OPTIONS,
} from "components/job/LineItem/constants";
import { calculateItemTotal } from "components/job/LineItem/helpers";

export interface FormattedLineItem {
  title?: string;
  description?: string;
  quantity?: string;
  price?: number;
  vat?: string;
  total?: number;
  style?: string;
  quoteDocument?: Document;
}

export interface LineItemContextPropsHook extends FormattedLineItem {
  classNames: LineItemVariant;
  variant?: string;
  kanda?: boolean;
}

export default function useLineItemContextProps(
  lineItem: JobItem,
  variant: string
): LineItemContextPropsHook {
  const { totalExcVat: subTotal, totalIncVat: total } = (lineItem &&
    lineItem?.quantity &&
    calculateItemTotal(
      lineItem?.quantity,
      lineItem?.price?.amount,
      lineItem?.vat_rate
    )) || {
    subTotal: 0,
    total: 0,
  };

  const vat =
    lineItem &&
    VAT_OPTIONS.reduce(
      (labels, option) => ({
        ...labels,
        [option.value]: option.name,
      }),
      {} as StringIndexedObject
    )[lineItem?.vat_rate || ""];

  const values = {
    title: lineItem?.title || "No line item title given...",
    description: lineItem?.description,
    quantity: `${lineItem?.quantity / 100} x`,
    price: subTotal,
    vat,
    total,
    style: lineItem?.style || "kanda",
    ...(lineItem?.quote_document
      ? { quoteDocument: lineItem.quote_document }
      : {}),
  };

  const classNames = VARIANTS[variant];

  const kanda = values.style === "kanda";

  return {
    classNames,
    variant,
    kanda,
    ...values,
  };
}
